import * as yup from "yup";

export const schema = yup.object().shape({
  email: yup
    .string()
    .email("O e-mail deve ser formatado corretamente")
    .required("Preencha esse campo obrigatório."),
  career: yup
    .boolean()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  represents: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  biggestChallenge: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  alreadyHadExperience: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  time: yup.string().required("Selecione pelo menos uma opção."),
  languages: yup.mixed().notRequired(),
  whyAreLookingForAProgrammingCourse: yup
    .array()
    .min(1, "Selecione pelo menos uma opção.")
    .required("Preencha esse campo obrigatório."),
  howMuchTimeAreLooking: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  objective: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  howMuchMoney: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
});
